module.exports = __webpack_public_path__ + "static/media/life.e68740ec.svg";